import React, { useEffect, useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import styles from './MainCarusel.module.scss';
import { getCaruselMain } from '../../../http/caruselAPI';
import CarouselItemContent from './CarouselItemContent/CarouselItemContent';
import { useCarouselItems } from '../../../hooks/useCarouselItems';

const MainCarusel = () => {
  const [carousel, setCarousel] = useState([]);
  const [carouselSlides, setCarouselSlides] = useState([]);
  const { items: processedItems } = useCarouselItems(carousel);
  
  if (!localStorage.getItem('cart')) {
    localStorage.setItem('cart', JSON.stringify([]));
  }
  const getCarousel = async () => {
    try {
      const data = await getCaruselMain();
      if (data.data.status) {
        setCarousel(data.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getCarousel();
  }, []);

  useEffect(() => {
    const items = processedItems.sortedActive || [];
    console.log("🚀 ~ MainCarusel ~ items:", items)

    if (items.length === 0) {
      setCarouselSlides([]);
      return;
    }

    let isCancelled = false;

    const preloadAll = async () => {
      const srcs = items.map((item) => {
        const isValid = (img) => img && img !== 'undefined';
        return isValid(item.imageFirst) ? item.imageFirst
          : isValid(item.imageUrl) ? item.imageUrl
            : null;
      }).filter(Boolean);

      const loaders = srcs.map((src) => new Promise((res) => {
        const img = new Image();
        img.onload = () => res({ src, status: 'ok' });
        img.onerror = () => res({ src, status: 'error' });
        img.src = src;
      }));

      try {
        await Promise.all(loaders);
      } catch (e) {
        // ignore individual load errors
      }

      if (isCancelled) return;

      const slides = items.map((item) => (
        <Carousel.Item key={item.order || item._id} className={styles.carouselItem}>
          <CarouselItemContent slide={item} />
        </Carousel.Item>
      ));

      setCarouselSlides(slides);
    };

    preloadAll();

    return () => { isCancelled = true; };
  }, [processedItems]);

  if (carouselSlides.length === 0) {
    return null;
  }

  return (
    <Carousel fade indicators interval={3000} className={styles.mainCarousel}>
      {carouselSlides}
    </Carousel>
  );
};

export default MainCarusel;
